import React from "react";

const Error = ({ message = "Something went wrong!", onRetry }) => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    padding: "20px",
    backgroundColor: "#f8f9fa",
  };

  const cardStyle = {
    width: "100%",
    maxWidth: "400px",
    padding: "30px 20px",
    borderRadius: "16px",
    backgroundColor: "#ffffff",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
  };

  const iconStyle = {
    fontSize: "50px",
    marginBottom: "15px",
  };

  const titleStyle = {
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "10px",
    color: "#333",
  };

  const messageStyle = {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px",
    lineHeight: "1.5",
  };

  const buttonStyle = {
    padding: "10px 20px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#0F8B50",
    color: "#fff",
    fontSize: "14px",
    cursor: "pointer",
    width: "100%",
  };

  const buttonHover = {
    backgroundColor: "#0c6f40",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={iconStyle}>⚠️</div>
        <div style={titleStyle}>Error</div>
        <div style={messageStyle}>{message}</div>

        {onRetry && (
          <button
            style={buttonStyle}
            onMouseOver={(e) =>
              (e.target.style.backgroundColor = buttonHover.backgroundColor)
            }
            onMouseOut={(e) =>
              (e.target.style.backgroundColor = buttonStyle.backgroundColor)
            }
            onClick={onRetry}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default Error